module.exports = __webpack_public_path__ + "static/media/news.0d67b044.svg";